import React, { FC } from 'react';
import cn from 'classnames';
import useToggle from 'react-use/lib/useToggle';
import hash from 'object-hash';
import st from './Schedule.module.css';

type ScheduleProps = {
  isServiceSchedule?: boolean;
  activeSchedule?: boolean;
  schedule: ScheduleTypeProps;
};

const Schedule: FC<ScheduleProps> = ({
  schedule,
  isServiceSchedule = false,
  activeSchedule = false,
}) => {
  const [active, activeToggle] = useToggle(false);

  const { serializeSchedules, currentDay } = schedule;

  const cnToggleBtn = cn(st.button, {
    [st.btnActive]: active || activeSchedule,
  });

  const cnToggleSchedule = cn(st.table, {
    [st.tableActive]: active || activeSchedule,
  });

  if (!serializeSchedules) {
    return null;
  }

  const serviceCurrentDay = currentDay.replace(
    'Работает ежедневно',
    'Ежедневно'
  );

  return (
    <div className={!isServiceSchedule ? st.schedule : st.scheduleService}>
      <button
        type="button"
        onClick={() => activeToggle()}
        className={cnToggleBtn}
      >
        {!isServiceSchedule ? currentDay : serviceCurrentDay}
      </button>
      <div className={cnToggleSchedule}>
        {serializeSchedules.map(item => (
          <div key={hash(item)} className={st.row}>
            <div className={st.day}>{item.daysOfWeekFull}</div>
            <div className={st.time}>{item.workDescription}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Schedule;
